import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../context/Store';
import Button from '../components/ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const { FiMessageCircle, FiCheck, FiShield, FiSend } = FiIcons;

const PublicDomain = () => {
  const { domainName } = useParams();
  const { getDomainByName } = useStore();
  
  // Try to find the domain, otherwise show a "Not Found" or "Demo" state
  const domain = getDomainByName(domainName) || { name: domainName, isDemo: true };

  const handleContact = (e) => {
    e.preventDefault();
    alert("Message sent to owner! (Mock action)");
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-2xl bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100"
      >
        {/* Header */}
        <div className="bg-indigo-600 p-8 sm:p-12 text-center text-white relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
          <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight mb-4 relative z-10">
            {domain.name}
          </h1>
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-1.5 rounded-full text-indigo-50 text-sm font-medium relative z-10">
            <SafeIcon icon={FiCheck} /> Verified Domain
          </div>
        </div>

        {/* Content */}
        <div className="p-8 sm:p-12">
          <div className="text-center mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-3">This domain is for sale!</h2>
            <p className="text-gray-500">
              The owner of <strong>{domain.name}</strong> is accepting offers. 
              Secure this premium digital asset for your business today.
            </p>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 mb-10">
            <div className="p-4 bg-gray-50 rounded-xl flex items-start gap-3">
              <SafeIcon icon={FiShield} className="text-indigo-600 mt-1" />
              <div>
                <h4 className="font-semibold text-gray-900 text-sm">Secure Transfer</h4>
                <p className="text-xs text-gray-500 mt-1">Ownership transferred safely via escrow service.</p>
              </div>
            </div>
            <div className="p-4 bg-gray-50 rounded-xl flex items-start gap-3">
               <SafeIcon icon={FiMessageCircle} className="text-indigo-600 mt-1" />
              <div>
                <h4 className="font-semibold text-gray-900 text-sm">Direct Negotiation</h4>
                <p className="text-xs text-gray-500 mt-1">Talk directly with the seller to close the deal.</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <form onSubmit={handleContact} className="space-y-4 max-w-md mx-auto">
            <div className="grid grid-cols-2 gap-4">
              <input 
                type="text" 
                placeholder="Name" 
                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none text-sm"
                required
              />
              <input 
                type="email" 
                placeholder="Email" 
                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none text-sm"
                required
              />
            </div>
            <input 
              type="number" 
              placeholder="Offer Amount ($)" 
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none text-sm"
              required
            />
            <textarea 
              placeholder="Message..." 
              rows="3"
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none text-sm resize-none"
            ></textarea>
            
            <Button type="submit" className="w-full h-12 text-base font-semibold shadow-lg shadow-indigo-200">
              Make an Offer <SafeIcon icon={FiSend} className="ml-2 w-4 h-4" />
            </Button>

            <button type="button" className="w-full flex items-center justify-center gap-2 text-green-600 font-medium text-sm hover:underline mt-4">
              <SafeIcon icon={FiMessageCircle} /> Chat on WhatsApp
            </button>
          </form>
        </div>
        
        <div className="bg-gray-50 p-4 text-center border-t border-gray-100">
          <p className="text-xs text-gray-400">
            Powered by <a href="/" className="font-bold text-gray-500 hover:text-indigo-600">Moloji</a>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default PublicDomain;